const REVEAL_SELECTOR = '.rv'
const VISIBLE_CLASS = 'in'
const THRESHOLD = 0.12

/**
 * Fades in `.rv` elements as they scroll into view, unobserving each one once
 * it has landed. Styling lives in src/styles/reveal.css.
 */
export function initReveal(root: ParentNode = document): void {
  const targets = root.querySelectorAll<HTMLElement>(REVEAL_SELECTOR)

  // Without IntersectionObserver, show everything rather than nothing.
  if (!('IntersectionObserver' in window)) {
    targets.forEach((el) => el.classList.add(VISIBLE_CLASS))
    return
  }

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue
        entry.target.classList.add(VISIBLE_CLASS)
        observer.unobserve(entry.target)
      }
    },
    { threshold: THRESHOLD },
  )

  targets.forEach((el) => observer.observe(el))
}
